import { render, staticRenderFns } from "./addCompanionsPC.vue?vue&type=template&id=4ba1e63c&scoped=true"
import script from "./addCompanionsPC.vue?vue&type=script&lang=js"
export * from "./addCompanionsPC.vue?vue&type=script&lang=js"
import style0 from "./addCompanionsPC.vue?vue&type=style&index=0&id=4ba1e63c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba1e63c",
  null
  
)

export default component.exports